import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import TableHeader from "../../../../components/Common/TableHeader";
import { NoRecordFound } from "../../../../components/Common/NoRecordFound";
import { CouponModel } from "../../../../interfaces/coupon.interface";

interface CouponTableProps {
    coupons: CouponModel[];
    setOpenDialog: (value: boolean) => void;
    setCouponId: (id: string) => void;
}

const CouponTable: React.FC<CouponTableProps> = ({ coupons, setOpenDialog, setCouponId }) => {
    return (
        <div className="w-full overflow-auto  flex flex-col justify-between">
            <>
                <div className="h-[17rem] md:h-[31rem]">
                    <table className="min-w-full  border border-gray-300 ">
                        {TableHeader([
                            "Coupon Code",
                            "Type",
                            "Apply On",
                            "Coupon Life",
                            "Description",
                            "Amount ($)",
                            "Expiry",
                            "",
                        ])}
                        <tbody>
                            {coupons && coupons.length > 0 ? (
                                coupons?.map((coupon, index) => (
                                    <tr key={index} className={index % 2 === 0 ? "bg-gray-100" : ""}>
                                        <td className="text-left py-2 px-4 border-b">{coupon.couponCode}</td>
                                        <td className="text-left py-2 px-4 border-b capitalize">{coupon.couponType}</td>
                                        <td className="text-left py-2 px-4 border-b">
                                            {coupon?.couponAppliedFor
                                                ? coupon?.couponAppliedFor.replace(/_/g, " ").replace("_", "").toUpperCase()
                                                : ""}
                                        </td>
                                        <td className="text-left py-2 px-4 border-b capitalize">
                                            {coupon?.couponValidity}
                                        </td>
                                        <td className="text-left py-2 px-4 border-b capitalize">
                                            {coupon?.couponDescription || "-"}
                                        </td>
                                        <td className="text-left py-2 px-4 border-b">
                                            {parseFloat(coupon.couponAmount!).toFixed(2)}
                                        </td>
                                        <td className="text-left py-2 px-4 border-b">{coupon.couponExpiry}</td>
                                        <td className="text-left py-4 px-4 border-b flex gap-5">
                                            <FontAwesomeIcon
                                                icon={faTrashCan}
                                                className="cursor-pointer"
                                                title="Delete Coupon"
                                                onClick={() => {
                                                    setOpenDialog(true);
                                                    setCouponId(coupon.id as string);
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <NoRecordFound colSpan={7} />
                            )}
                        </tbody>
                    </table>
                </div>
            </>
        </div>
    );
};

export default CouponTable;
